import { FC, useState } from "react";
import { useParams } from "react-router-dom";
import useI18n from "../../../../../hooks/useTranslations";
import Button from "../../../../ui/Button";
import ModalDialog from "../../../../ui/ModalDialog";
import AbsorberForm from "./AbsorberForm";
import SystemAbsorberForm from "./SystemAbsorberForm";

const CreateAbsorberModalDialogButton: FC = () => {
  const i18n = useI18n();
  const [showNewItemDialog, setShowNewItemDialog] = useState(false);
  const { patrolSystemId } = useParams<{ patrolSystemId: string }>();

  return (
    <>
      <Button buttonProps={{ onClick: () => setShowNewItemDialog(true) }}>{i18n.translation.common.createNew}</Button>
      {showNewItemDialog && (
        <ModalDialog onClose={() => setShowNewItemDialog(false)} title={i18n.translation.absorbers.createNew}>
          {patrolSystemId ? (
            <SystemAbsorberForm onClose={() => setShowNewItemDialog(false)} />
          ) : (
            <AbsorberForm onClose={() => setShowNewItemDialog(false)} />
          )}
        </ModalDialog>
      )}
    </>
  );
};

export default CreateAbsorberModalDialogButton;
